// =============================================================================
//  KONSTANTEN: Wertungen (Classifications)
// =============================================================================
//  Zweck: Eine zentrale Liste aller möglichen Wertungen für Turniere.
// =============================================================================

export const CLASSIFICATIONS = [
  // Einzelwertungen

// NEU: Erweiterung um diverse Altersklassen
  { key: 'u10_w', label: 'U10 weiblich' },
  { key: 'u10_m', label: 'U10 männlich' },
  { key: 'u15_w', label: 'U15 weiblich' },
  { key: 'u15_m', label: 'U15 männlich' },
  { key: 'u19_w', label: 'U19 weiblich' },
  { key: 'u19_m', label: 'U19 männlich' },
  { key: 'u23_w', label: 'U23 weiblich' },
  { key: 'u23_m', label: 'U23 männlich' },
  { key: 'allg_w', label: 'Allgemeine Klasse weiblich' },
  { key: 'allg_m', label: 'Allgemeine Klasse männlich' },
  { key: 'ue50_w', label: 'Ü50 weiblich' },
  { key: 'ue50_m', label: 'Ü50 männlich' },
  { key: 'ue60_w', label: 'Ü60 weiblich' },
  { key: 'ue60_m', label: 'Ü60 männlich' },
  // ENDE NEU

  { key: 'damen_classic', label: 'Damen Classic' },
  { key: 'herren_classic', label: 'Herren Classic' },
  { key: 'damen_breitensport', label: 'Damen Breitensport' },
  { key: 'herren_breitensport', label: 'Herren Breitensport' },
  // Mannschaftswertungen
  { key: 'team_damen_classic', label: 'Mannschaft Damen Classic' },
  { key: 'team_herren_classic', label: 'Mannschaft Herren Classic' },
  { key: 'team_mixed_classic', label: 'Mannschaft Mixed Classic' },
  { key: 'team_damen_breitensport', label: 'Mannschaft Damen Breitensport' },
  { key: 'team_herren_breitensport', label: 'Mannschaft Herren Breitensport' },
  { key: 'team_mixed_breitensport', label: 'Mannschaft Mixed Breitensport' },
];